import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { getInitials } from '../../helpers';

interface MemoryCardHeaderProps {
  variant: 'memory' | 'timeline' | 'sprk';
  dedicated_to: string;
  name: string;
  date: string;
};

const MemoryCardHeader: React.FC<MemoryCardHeaderProps> = ({ variant, dedicated_to, name, date }) => {
  return (
    <div className="memory-card-header wa-cluster wa-gap-xs">
      <wa-avatar initials={getInitials(name)} style={{ '--size': '28px' }} />
      <div className="wa-stack wa-gap-0">
        {variant === 'memory' && (
          <div className="memory-card-dedicated-to">
            {dedicated_to === '<placeholder>' ? <Skeleton /> : dedicated_to}
          </div>
        )}
        <div className="memory-card-meta">
          {date} by {name}
        </div>
      </div>
    </div>
  );
}

export default MemoryCardHeader;
